import { render, staticRenderFns } from "./F3Modal.vue?vue&type=template&id=505d8796&scoped=true&"
import script from "./F3Modal.vue?vue&type=script&lang=js&"
export * from "./F3Modal.vue?vue&type=script&lang=js&"
import style0 from "./F3Modal.vue?vue&type=style&index=0&id=505d8796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d8796",
  null
  
)

export default component.exports